

var sHero, sEscapadas, sHotel;
var mySwiper = {
    init: function(){
        mySwiper.hero();
        mySwiper.hotel();
        mySwiper.escapadas();
        mySwiper.changeTab();
        
    },
    hero: function(){
        sHero = new Swiper(".swiper-container.swiper-hero", {
            spaceBetween: 0,
            loop: true,
            grabCursor: true,
        });
    },
    hotel: function(){
        sHotel = new Swiper(".swiper-container.swiper-hotel", {
            spaceBetween: 30,
            loop: true,
            grabCursor: true,
            autoplay: {
                delay: 5000,
            },
    
            breakpoints: {
                992: {
                    effect: "coverflow",
                    loop: true,
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: "auto",
                    coverflowEffect: {
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        modifier: 0.75,
                        slideShadows: false,
                    }
                }
            }
        });
    },
    escapadas: function(){
        sEscapadas = new Swiper(".swiper-container.swiper-escapadas", {
            spaceBetween: 0,
            loop: true,
            grabCursor: true,
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 5000,
            },
        });
    },
    destroyHotel: function(){
        $(sHotel).each(function(index, element){
            sHotel[index].destroy(true, true);
        });
    },
    changeTab: function(){
        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            mySwiper.destroyHotel();
            mySwiper.hotel();
        });
    }
};

$(function () {
    mySwiper.init();
});